module.exports = __webpack_public_path__ + "media/images/icon__point--lost-59e6e33aa855326607210bbe5e08a61a.png";